import { render, staticRenderFns } from "./openingBlock.vue?vue&type=template&id=09010fae&scoped=true"
import script from "./openingBlock.vue?vue&type=script&lang=js"
export * from "./openingBlock.vue?vue&type=script&lang=js"
import style0 from "./openingBlock.vue?vue&type=style&index=0&id=09010fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09010fae",
  null
  
)

export default component.exports